import React, { useState, useEffect } from "react";
import { createLabTestCategory, getLabTestCategoryById,updateLabTestCategory } from "../../apis/LabOrder"; 

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (category: any) => void;
  editableId?: number;
  editableCategory?: any;
};

const AddNewCategory: React.FC<Props> = ({ isOpen, onClose, onSuccess, editableId, editableCategory }) => {
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const isEditMode = Boolean(editableId);

useEffect(() => {
  const fetchCategory = async () => {
    if (editableId) {
      try {
        const res = await getLabTestCategoryById(editableId);
        const category = res.data.data || res.data;
        setName(category.name || "");
      } catch (err) {
        console.error("Failed to fetch category:", err);
      }
    } else if (editableCategory) {
      setName(editableCategory.name || "");
    } else {
      setName("");
    }
    setError("");
  };

  fetchCategory();
}, [editableId, editableCategory]);

const handleSubmit = async () => {
  if (!name.trim()) {
    setError("Name is required");
    return;
  }

  try {
    setLoading(true);
    let savedCategory;

    if (editableId) {
      // Update existing category
      const response = await updateLabTestCategory(editableId, { name });
      savedCategory = response.data.data || response.data;
    } else {
      // Create new category
      const response = await createLabTestCategory({ name });
      savedCategory = response.data.data || response.data;
    }

    onSuccess(savedCategory);
    setName("");
    setError("");
    onClose();
  } catch (err: any) {
    console.error("Failed to save category:", err);
    setError("Failed to save category");
  } finally {
    setLoading(false);
  }
};

const handleCancel = () => {
  setName("");
  setError("");
  onClose();
};

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
        {/* Header */}
        <div className="flex items-center justify-between bg-primary px-4 py-3 rounded-t-lg">
                  <h2 className="text-lg font-semibold text-white">
                      {editableId ? "Update Category" : "Add New Category"}
                  </h2>
          <button
            onClick={handleCancel}
            className="text-white text-xl font-bold hover:text-gray-200"
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-900">
              Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="mt-1 block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
            {error && <span className="text-sm text-red-500">{error}</span>}
          </div>

          {/* Buttons */}
          <div className="flex items-center justify-start gap-x-4 border-t border-gray-200 pt-4">
            <button
    type="button"
    onClick={handleSubmit}
    disabled={loading}
    className="px-4 py-2 text-sm font-semibold text-white rounded-md bg-primary hover:bg-hover disabled:opacity-50 disabled:cursor-not-allowed"
  >
    {loading ? (isEditMode ? "Updating..." : "Saving...") : isEditMode ? "Update" : "Save"}
  </button>
            <button
              onClick={handleCancel}
              type="button"
              className="text-sm font-semibold leading-6 text-gray-900"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewCategory;
